import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Col, Row } from 'reactstrap';
import { actions } from '../../../context';
import Split from '../../Shared/Split';
import Lock from '../Shared/Lock';
import NewButton from '../Shared/NewButton';
import ManageAccountsModal from './Accounts/ManageAccountsModal';
import PartnerAccount from './Accounts/PartnerAccount';
import Domain from './Domains/Domain';
import DomainForm from './Domains/NewDomain';
import PartnerInfo from './PartnerInfo';
import NewPartnerOffering from './PartnerOfferings/NewPartnerOffering';
import PartnerOffering from './PartnerOfferings/PartnerOffering';

// TODO: this componenet is doing too much, break it up
const Partner = () => {
    const dispatch = useDispatch();
    const { partnerId } = useParams();

    const [partner, setPartner] = useState({});

    const [locked, setLocked] = useState(true);
    const toggleLocked = useCallback(() => setLocked(!locked), [locked]);

    const [addingAccount, setAddingAccount] = useState(false);
    const toggleAddingAccount = useCallback(
        () => setAddingAccount(!addingAccount),
        [addingAccount]
    );

    const [addingDomain, setAddingDomain] = useState(false);
    const toggleAddingDomain = useCallback(
        () => setAddingDomain(!addingDomain),
        [addingDomain]
    );

    const [addingOffering, setAddingOffering] = useState(false);
    const toggleAddingOffering = useCallback(
        () => setAddingOffering(!addingOffering),
        [addingOffering]
    );

    const refresh = useCallback(
        () =>
            dispatch(actions.partner.getPartner(partnerId)).then((res) =>
                setPartner(res)
            ),
        [dispatch, partnerId]
    );

    useEffect(() => {
        setLocked(true);
        refresh();
        // eslint-disable-next-line
    }, [dispatch, partnerId]);

    return (
        <>
            <DomainForm
                isOpen={addingDomain}
                partnerId={partnerId}
                refresh={refresh}
                toggle={toggleAddingDomain}
            />
            <NewPartnerOffering
                isOpen={addingOffering}
                partnerId={partnerId}
                refresh={refresh}
                toggle={toggleAddingOffering}
            />
            <ManageAccountsModal
                isOpen={addingAccount}
                partnerId={partnerId}
                refresh={refresh}
                toggle={toggleAddingAccount}
            />
            <Split>
                <div>&nbsp;</div>
                <h1>{partner?.name || 'Loading'}</h1>
                <Lock isLocked={locked} onClick={toggleLocked} size="2x" />
            </Split>
            <PartnerInfo
                title="Accounts"
                locked={locked}
                button={
                    <NewButton
                        id="addAccount"
                        title="Add account"
                        onClick={toggleAddingAccount}
                        size="sm"
                    />
                }>
                <div className="d-flex flex-wrap">
                    {/* TODO: perhaps turn this into a function or compoenent so we can memoize it based on accounts array */}
                    {/* the concept above applies to lots of places in code */}
                    {(partner?.accounts || []).map((a, x) => (
                        <PartnerAccount key={a.id} accountId={a.id} fullName={a.fullName} email={a.email} role={a.role} />
                    ))}
                </div>

                {(partner?.accounts || []).length === 0 && (
                    <div className="op-7">No accounts for this partner</div>
                )}
            </PartnerInfo>
            <PartnerInfo
                title="Offerings"
                locked={locked}
                button={
                    <NewButton
                        id="newPartnerOffering"
                        title="Add partner offering"
                        onClick={toggleAddingOffering}
                        size="sm"
                    />
                }>
                <Row className="d-flex flex-wrap">
                    {(partner?.partnerOfferings || []).map((o) => (
                        <Col key={o.id} lg="4" md="4" sm="12" xs="12">
                            <PartnerOffering
                                refresh={refresh}
                                offering={o}
                                locked={locked}
                            />
                        </Col>
                    ))}
                </Row>
                {(partner?.partnerOfferings || []).length === 0 && (
                    <div className="op-7">No offerings for this partner</div>
                )}
            </PartnerInfo>
            <PartnerInfo
                title="Domains"
                locked={locked}
                button={
                    <NewButton
                        id="newDomainButton"
                        title="Add domain to partner"
                        onClick={toggleAddingDomain}
                        size="sm"
                    />
                }>
                {(partner?.trustedDomains || []).map((d) => (
                    <Domain key={d.id} domainId={d.id} domainName={d.name} refresh={refresh} locked={locked} />
                ))}
                {(partner?.trustedDomains || []).length === 0 && (
                    <div className="op-7">No domains for this partner</div>
                )}
            </PartnerInfo>
        </>
    );
};

export default Partner;
